import script from "./SideNavBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavBarItem.vue?vue&type=script&setup=true&lang=js"

import "./SideNavBarItem.vue?vue&type=style&index=0&id=68431dd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68431dd4"]])

export default __exports__